import React, { useState, useEffect } from 'react';
import { useSnackbarContext } from '../contexts/Snackbar';
import { getPayments } from '../components/API/payment';
import LoadingBackdrop from '../components/LoadingBackdrop';
import Layout from '../components/PaymentsTwo/Layout';
export default function Payments() {
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState(null);
  const [debit, setDebit] = useState(0);
  const [onGoingPayments, setOnGoingPayments] = useState(0);
  const snackbar = useSnackbarContext();

  async function getPaymentsWrapper() {
    setLoading(true);
    try {
      const {
        data: paymentTable,
        currentDebit,
        currentOngoing,
      } = await getPayments();
      setPayments(paymentTable);
      setDebit(currentDebit);
      setOnGoingPayments(currentOngoing);
    } catch (e) {
      setPayments([]);
      snackbar.show(
        'We encountered an issue while attempting to retrieve your payments. Please try again.',
        'error',
      );
    }
    setLoading(false);
  }

  useEffect(() => {
    getPaymentsWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {payments && (
        <Layout
          payments={payments}
          debit={debit}
          onGoingPayments={onGoingPayments}
          setLoading={setLoading}
          setPayments={setPayments}
        />
      )}
    </React.Fragment>
  );
}
